<app-button [type]="type"
            [disabled]="disabled || (popupService.isWorkInProgress$ | async) === true"
            [icon]="icon"
            (click)="execute()">
    <ng-content></ng-content>
</app-button>
